import _ from "lodash";

export default function diffObjects<T extends object>(
    updated: T,
    old: T
  ): Partial<T> {
    const out: Partial<T> = {};
    (Object.keys(updated) as Array<keyof T>).forEach((k) => {
      if (!_.isEqual(updated[k], old[k])) {
        out[k] = _.cloneDeep(updated[k]) as T[typeof k];
      }
    });
    return out;
  }